import { NDfPrivacy } from '@df/module-privacy/df-module-privacy.interfaces';

NDfPrivacy.ALLOWED_AREAS[NDfPrivacy.AREA.advertising] = ['stc111474', 'rmStore', '_rmco', '_rmco_cs', '_rmco_jsv'];
